import React, {useState} from "react";
import {FormattedMessage, useIntl} from "react-intl";
import auth from "../../../utils/authentication";
import {toast} from "react-toastify";

const VerificationStatus = ({className, style}) => {

    const intl = useIntl();

    const [sent, setSent] = useState(false)
    let [secondsLeft, setSecondsLeft] = useState(0)

    function sendVerificationEmail() {
        auth.currentUser.sendEmailVerification().then(() => {
            setSent(true);
            toast.success(intl.formatMessage({id: "app.verify-account.send-success"}))
            tryAgainCountdown();
        }).catch(error => {
            console.log(error);
        })
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    async function tryAgainCountdown() {
        setSecondsLeft(30);
        secondsLeft = 30;
        while (secondsLeft > 0) {
            setSecondsLeft(secondsLeft - 1);
            secondsLeft--;
            await sleep(1000);
        }
        setSecondsLeft(0);
        setSent(false);
    }

    return (
        <div className={"card button-menu " + className + ` ${sent ? 'disabled' : ''}`}
             onClick={sendVerificationEmail}
             style={{cursor: "pointer", userSelect: "none", textDecoration: "none", ...style}}>
            <div className="card-body d-flex flex-wrap col-12">
                <div className="col-12 d-flex flex-row" style={{fontSize: "large", fontWeight: "500"}}>
                    <div className="col-1 me-3">
                        <i className="fa-solid fa-paper-plane"/>
                    </div>
                    <div className="col-11">
                        <FormattedMessage id="app.verify-account"/>
                    </div>
                </div>
                <div className="col-12 d-flex flex-row">
                    <div className="col-1 me-3">
                    </div>
                    {!sent && <div className="col-11" style={{fontSize: "small", fontWeight: "lighter"}}>
                        <FormattedMessage id="app.verify-account-message"/>
                    </div>}
                    {sent && <div className="col-11" style={{fontSize: "small", fontWeight: "lighter"}}>
                        <div>
                            <FormattedMessage id="app.verify-account-again"/>
                        </div>
                        <div>
                            <FormattedMessage id="app.verify-account-again.countdown"/>{secondsLeft}s
                        </div>
                    </div>}
                </div>
            </div>
        </div>
    );
};

export default VerificationStatus;
